import type * as React from 'react';

import { PageLayoutOptionsWidth } from '@gitbook/hive-core';
import { type TileOption, TilePicker } from '@gitbook/spine-react';

import widthDefaultDarkImage from './assets/width-default-dark.svg';
import widthDefaultLightImage from './assets/width-default-light.svg';
import widthWideDarkImage from './assets/width-wide-dark.svg';
import widthWideLightImage from './assets/width-wide-light.svg';
import type { PageLayoutOptionsProps } from './types';

/**
 * Options to configure content on a page.
 * Through this, we can toggle page title & description visibility and also
 * change the width of the blocks.
 */
export function PageOptionsWidth(props: PageLayoutOptionsProps): React.ReactElement {
    const { pageOptions, setPageOptionsUpdate } = props;
    return (
        <TilePicker
            items={OPTIONS}
            selectedItem={pageOptions.layoutOptions.width ?? PageLayoutOptionsWidth.Default}
            setSelectedItem={(value: PageLayoutOptionsWidth) =>
                setPageOptionsUpdate({
                    layoutOptions: {
                        ...pageOptions.layoutOptions,
                        width: value,
                    },
                })
            }
        />
    );
}

const OPTIONS: TileOption<PageLayoutOptionsWidth>[] = [
    {
        value: PageLayoutOptionsWidth.Default,
        label: 'Default',
        asset: {
            light: widthDefaultLightImage,
            dark: widthDefaultDarkImage,
        },
    },
    {
        value: PageLayoutOptionsWidth.Wide,
        label: 'Wide',
        asset: {
            light: widthWideLightImage,
            dark: widthWideDarkImage,
        },
    },
];
